import {
  Menu,
  UnstyledButton,
  Group,
  Avatar,
  Text,
  rem,
  useMantineColorScheme,
} from "@mantine/core";
import {
  IconCheck,
  IconLogout,
  IconMoon,
  IconPalette,
  IconSun,
  IconUser,
} from "@tabler/icons-react";
import { BRAND_PALETTE_OPTIONS } from "../../theme/brandPalettes";
import { useBrandTheme } from "../../theme/BrandThemeContext";

interface UserMenuProps {
  name: string;
  email: string;
  onLogout: () => void;
}

export function UserMenu({ name, email, onLogout }: UserMenuProps) {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const { paletteKey, setPaletteKey } = useBrandTheme();
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <Menu shadow="md" width={220} position="bottom-end">
      <Menu.Target>
        <UnstyledButton>
          <Group gap="xs">
            <Avatar radius="xl" size="sm" color="brand">
              {initials}
            </Avatar>
            <div style={{ lineHeight: 1 }}>
              <Text size="sm" fw={500}>
                {name}
              </Text>
              <Text size="xs" c="dimmed">
                {email}
              </Text>
            </div>
          </Group>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Account</Menu.Label>
        <Menu.Item
          leftSection={<IconUser style={{ width: rem(14), height: rem(14) }} />}
          disabled
        >
          Profile
        </Menu.Item>
        <Menu.Divider />
        <Menu.Label>Appearance</Menu.Label>
        <Menu.Item
          leftSection={
            colorScheme === "dark" ? (
              <IconSun style={{ width: rem(14), height: rem(14) }} />
            ) : (
              <IconMoon style={{ width: rem(14), height: rem(14) }} />
            )
          }
          onClick={toggleColorScheme}
        >
          {colorScheme === "dark" ? "Light mode" : "Dark mode"}
        </Menu.Item>
        <Menu.Label>Brand palette</Menu.Label>
        {BRAND_PALETTE_OPTIONS.map((palette) => (
          <Menu.Item
            key={palette.key}
            leftSection={
              <IconPalette
                color={palette.primary}
                style={{ width: rem(14), height: rem(14) }}
              />
            }
            rightSection={
              palette.key === paletteKey ? (
                <IconCheck style={{ width: rem(14), height: rem(14) }} />
              ) : null
            }
            onClick={() => setPaletteKey(palette.key)}
          >
            {palette.label}
          </Menu.Item>
        ))}
        <Menu.Divider />
        <Menu.Item
          color="red"
          leftSection={<IconLogout style={{ width: rem(14), height: rem(14) }} />}
          onClick={onLogout}
        >
          Sign out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
